import React from "react";
import {cx} from "../../lib/ClassSet";
import "./ProductWaitingListItem.css";
import format from 'date-fns/format'

const ProductWaitingListItem = (props) => {

  let {data} = props;

  let subscribedAt = format(data.get("createdAt"), "MMM D, YYYY");

  let classes = cx({
    "item": true,
    "product-wating-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("shopId")}</td>
      <td className="field f-name">{data.getIn(["customer", "name"])}</td>
      <td className="field f-email">{data.getIn(["customer", "email"])}</td>
      <td className="field f-id">{data.get("sku")}</td>
      <td className="field">{data.get("kind")}</td>
      <td className="field f-date">{subscribedAt}</td>
    </tr>
  )
}

export default ProductWaitingListItem;